module.exports = __webpack_public_path__ + "static/img/company26.67b89be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/company26.png
// module id = /mPE
// module chunks = 0